import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const deskingRequest = createAction(types.DESKING_REQUEST);
export const deskingSuccess = createAction(types.DESKING_SUCCESS);
export const deskingFailure = createAction(types.DESKING_FAILURE);

export const setDesking = createAction(types.SET_DESKING);
export const setDeskingOffers = createAction(types.SET_DESKINGOFFERS);
export const setPartialOffers = createAction(types.SET_PARTIALOFFERS);

export const deskingSendToSalesperson = createAction(
  types.DESKING_SEND_TO_SALESPERSON_REQUEST,
);
export const deskingSendToSalespersonSuccess = createAction(
  types.DESKING_SEND_TO_SALESPERSON_SUCCESS,
);
export const deskingSendToSalespersonFailure = createAction(
  types.DESKING_SEND_TO_SALESPERSON_FAILURE,
);

export const createDeskingOffer = createAction(
  types.DESKINGOFFER_CREATE_REQUEST,
);
export const createDefaultDeskingOffer = createAction(
  types.DESKINGOFFER_CREATE_DEFAULT_REQUEST,
);
export const deskingOfferCreateSuccess = createAction(
  types.DESKINGOFFER_CREATE_SUCCESS,
);
export const deskingOfferCreateFailure = createAction(
  types.DESKINGOFFER_CREATE_FAILURE,
);

export const bulkUpdateDeskingOffer = createAction(
  types.DESKINGOFFER_BULK_UPDATE_REQUEST,
);
export const bulkDeskingOfferUpdateSuccess = createAction(
  types.DESKINGOFFER_BULK_UPDATE_SUCCESS,
);
export const bulkDeskingOfferUpdateFailure = createAction(
  types.DESKINGOFFER_BULK_UPDATE_FAILURE,
);

export const deleteDeskingOffer = createAction(
  types.DESKINGOFFER_DELETE_REQUEST,
);
export const deskingOfferDeleteSuccess = createAction(
  types.DESKINGOFFER_DELETE_SUCCESS,
);
export const deskingOfferDeleteFailure = createAction(
  types.DESKINGOFFER_DELETE_FAILURE,
);

export const pushCrmDeskingOffer = createAction(
  types.DESKINGOFFER_CRM_PUSH_REQUEST,
);
export const pushCrmDeskingOfferSuccess = createAction(
  types.DESKINGOFFER_CRM_PUSH_SUCCESS,
);
export const pushCrmDeskingOfferFailure = createAction(
  types.DESKINGOFFER_CRM_PUSH_FAILURE,
);
